import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";

@Component({
    selector: 'allow-comments-preview',
    templateUrl: 'allow-comments-preview.component.html',
    styleUrls: ['./allow-comments-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        NgClass,
    ]
})
export class AllowCommentsPreviewComponent {

    @Input() allowComments: boolean;
  
    constructor() {}
}

